import React from 'react';
import { useNavigate } from 'react-router-dom';

import { CheckCircle, Mail } from 'lucide-react';

import reputationScore from '../../../assets/reputationScore.png';
import nps from '../../../assets/nps.png';
import reviewInsights from '../../../assets/reviewInsights.png';

const InfoSection = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-blue-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <div className="card text-center mb-8">
          <div className="flex justify-center mb-6">
            <div className="bg-success-100 p-4 rounded-full">
              <CheckCircle className="w-12 h-12 text-success-600"/>
            </div>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Thank you so much!
          </h1>
          
          <p className="text-lg text-gray-600 mb-6">
            Your request has been received and we're preparing your Reputation Audit Report.
          </p>
          
          <div className="bg-success-50 border border-success-200 rounded-lg p-4 mb-6">
            <div className="flex items-center justify-center gap-2 text-success-700">
              <Mail className="w-5 h-5"/>
              <span className="font-medium">Your report will be emailed to you</span>
            </div>
          </div>
        </div>
        
        <div className="mt-8">
          <h3 className="text-lg font-semibold text-gray-900 mb-4 text-center">
            What Your Report Will Look Like:
          </h3>
          
          <div className="grid md:grid-cols-3 gap-4">
            <div className="bg-white rounded-lg shadow-md overflow-hidden max-w-sm mx-auto">
              <div className="flex items-center justify-center">
                <img
                  src={reputationScore}
                  alt="Reputation Score"
                  className="w-full h-full"
                />
              </div>
              
              <div className="p-4">
                <h4 className="font-medium text-gray-900 mb-1">Reputation Score</h4>
                <p className="text-xs text-gray-600">Comprehensive metrics and analysis</p>
              </div>
            </div>
            
            <div className="bg-white rounded-lg shadow-md overflow-hidden max-w-sm mx-auto">
              <div className="flex items-center justify-center">
                <img
                  src={nps}
                  alt="Net Promoter Score"
                  className="w-full h-full"
                />
              </div>
              
              <div className="p-4">
                <h4 className="font-medium text-gray-900 mb-1">NPS Analysis</h4>
                <p className="text-xs text-gray-600">Customer loyalty insights</p>
              </div>
            </div>
            
            <div className="bg-white rounded-lg shadow-md overflow-hidden max-w-sm mx-auto">
              <div className="flex items-center justify-center">
                <img
                  src={reviewInsights}
                  alt="Reviews Insights"
                  className="w-full h-full"
                />
              </div>
              
              <div className="p-4">
                <h4 className="font-medium text-gray-900 mb-1">Review Insights</h4>
                <p className="text-xs text-gray-600">Detailed sentiment analysis</p>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500 mb-4">
            Can't find the email? Check your spam folder or contact us at support@localyser.com
          </p>
          
          <button
            onClick={() => navigate('/')}
            className="btn-secondary"
          >
            ← Back to Search
          </button>
        </div>
      </div>
    </div>
  );
};

export default InfoSection;
